export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7319.b391d095.jpg";